import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "big-icon top-left fill-block" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "previews fill-block" }
const _hoisted_4 = { class: "preview-container fill-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FolderIcon = _resolveComponent("FolderIcon")!
  const _component_XImg = _resolveComponent("XImg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    draggable: "false",
    class: _normalizeClass(["folder fill-block", {
      [`folder--${_ctx.sanitizedName}`]: true,
    }]),
    to: _ctx.target
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FolderIcon, { class: "icon" }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previews, (info) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "img-outer",
              key: info.fileid
            }, [
              _createVNode(_component_XImg, {
                class: "ximg fill-block",
                src: _ctx.previewUrl(info)
              }, null, 8, ["src"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "to"]))
}